import { Box, Button, Tooltip } from '@mui/material';
import { colors, defaultButtonSX } from '@src/styles';

type ITexStatus = 'ENABLED' | 'DISABLED';

interface TexStatusProps {
  data: {
    isLoading: boolean;
    status?: ITexStatus;
  };
}

const statusMapMessage: Record<ITexStatus, string> = {
  ENABLED: 'Extensão ativa para a organização',
  DISABLED: 'Extensão desligada para a organização',
};

const TexStatus: React.FC<TexStatusProps> = ({ data }) => {
  if (data.isLoading) {
    return (
      <Box>
        <Button
          size="small"
          sx={{
            ...defaultButtonSX,
            minWidth: 'auto',
            padding: '6px',
            width: 18,
            height: 18,
            marginRight: '10px',
            borderRadius: '20px',
            color: colors.primary.white,
            backgroundColor: colors.background.secondary,
            '&:hover': {
              backgroundColor: colors.primary.yellow,
              color: colors.background.primary,
            },
          }}
        ></Button>
      </Box>
    );
  }

  return (
    <Box>
      <Tooltip title={statusMapMessage[data.status]} arrow>
        <Button
          size="small"
          sx={{
            ...defaultButtonSX,
            minWidth: 'auto',
            padding: '6px',
            width: 18,
            height: 18,
            marginRight: '10px',
            borderRadius: '20px',
            color: colors.primary.white,
            backgroundColor: data.status === 'ENABLED' ? '#51F55E' : '#FC2121',
            border: '0.1px black solid',
            '&:hover': {
              backgroundColor: colors.primary.yellow,
              color: colors.background.primary,
            },
          }}
        ></Button>
      </Tooltip>
    </Box>
  );
};

export default TexStatus;
